import React, {MouseEventHandler, ReactNode} from "react";
import styled from "@emotion/styled";

interface IconButtonProps {
    text: string;
    icon: ReactNode;
    onClick?: MouseEventHandler;
}

const IconButtonStyled = styled.div({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
    color: "var(--color-green-dark)",
    fontSize: "16px",
    fontWeight: "bold",
    padding: "8px 16px",
    border: "2px solid #669933",
    borderRadius: "25vh",
    transition: "background-color 150ms linear",
    cursor: "pointer",
})

function IconButton(props: IconButtonProps) {

    const { text, icon, onClick } = props;

    return (
        <IconButtonStyled className="IconButton" onClick={onClick}>
            {text}
            {icon}
        </IconButtonStyled>
    );
}

export default IconButton;